import React from 'react';
import PropTypes from 'prop-types';

/**
 * Responsive header column
 * Wraps display name elements with span with given CSS classes
 *
 * @param {{}} props
 * @constructor
 */
const ResponsiveHeader = props => (
    <span className="ResponsiveHeader">
        {props.displayName.map((options, index) =>
            <span className={options.className} key={index}>{options.displayName}</span>
        )}
    </span>
);

ResponsiveHeader.propTypes = {
    /**
     * Array of header responsive chunks
     */
    displayName: PropTypes.array.isRequired
};

export default ResponsiveHeader;



// WEBPACK FOOTER //
// ./src/js/components/DataTable/ResponsiveHeader.js